import React, { useEffect, useState } from "react";
import axios from "axios";
import { AiFillPlayCircle } from "react-icons/ai";
import NoImg from "./NoImg.jpg";
import { container } from "./NavBar";
import "../Styles/video.css";
import { useContext } from "react";
import { AiOutlineClose } from "react-icons/ai";
import TrailerMovies from "../Trailers/TrailerMovies";


const Movies = () => {
  const { toggle, inputValue } = useContext(container);
  const input = inputValue;
  const [moviesData, setMoviesData] = useState([]);
  const [trailer, setTrailer] = useState(true);
  const [movieTitle, setMovieTitle] = useState("");
  const shown = input ? "search" : "discover";

  const API = `https://api.themoviedb.org/3/${shown}/movie`;
  const Images = "https://image.tmdb.org/t/p/w500/";

  const moviesCall = async () => {
    const data = await axios.get(API, {
      params: {
        api_key: "f14fc28bd5ca473908ddb62bd3f18aff",
        query: input,
      },
    });
    const results = data.data.results;
    setMoviesData(results);
  };

  useEffect(() => {
    setTimeout(() => {
      moviesCall();
    }, 100);
  }, [input]);
  console.log(moviesData);


  const MoviesTitle = (movie) => {
    setMovieTitle(movie.title);
    setTrailer(!trailer);
  };

  return (
    <>
      <div className={toggle ? "mainBgColor" : "secondaryBgColor"}>
        <div className="movies-container">
          {moviesData.map((movie) => {
            return (
              <div id={trailer ? "container" : "NoContainer"} key="id">
                <AiFillPlayCircle
                  color="#fff"
                  fontSize={40}
                  id={trailer ? "playIcon" : "hide"}
                  onClick={() => MoviesTitle(movie)}
                />
                <img
                  src={
                    movie.poster_path ? `${Images}${movie.poster_path}` : NoImg
                  }
                  alt=""
                  onClick={() => MoviesTitle(movie)}
                />
                <h3 id={movie.title.length > 20 ? "smaller-Text" : ""}  className={toggle ?"mainColor":"secondaryColor"}>
                  {movie.title.substr(0,15)}
                </h3>
              </div>
            );
          })}
          {trailer ? console.log("dfdf") : <TrailerMovies moviesTitle ={movieTitle} toggle={toggle}/>}
          <AiOutlineClose
            id={trailer ? "Nothing" : "Exit1"}
            className={toggle ? "DarkTheme" : "LightThemeClose"}
            fontSize={55}
            color="#fff"
            cursor={"pointer"}
            onClick={() => setTrailer(true)}
          />
        </div>
      </div>
    </>
  );
};

export default Movies;
